import { rangePresets } from '@gogame/intl-ts';

//filters
export const FILTERS = 'filters';
export const FILTER_CREATED = 'created';
export const FILTER_ACTIVITY = 'activity';
export const FILTER_ACTIVITY_TYPES = 'activityTypeIds';
export const FILTER_ATTRIBUTION = 'attributionTypeIds';
export const FILTER_TYPES = 'typeIds';
export const FILTER_REWARDS_TYPES = 'rewardTypeIds';
export const FILTER_STATUSES = 'statusIds';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_REWARDS = 'rewardsIds';
export const FILTER_REQUESTED_BY = 'requestedByIds';

export const FILTER_DEPENDENCIES = {
  [FILTER_REWARDS]: [FILTER_APPLICATIONS],
};

export const ADDED_PERIOD_PRESETS = [
  rangePresets.THIS_MONTH,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LIFETIME,
];

export const ACTIVITY_PERIOD_PRESETS = [
  rangePresets.THIS_MONTH,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LIFETIME,
];

// searchQuery
export const SEARCH_QUERY = 'searchQuery';
export const TABLE_SETTINGS = 'tableSettings';

// columns
export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_STATUS = 'status';
export const COLUMN_CONDITION_REWARDS = 'conditions';
export const COLUMN_GG_CAMPAIGNS = 'goGameCampaigns';
export const COLUMN_PLATFORMS = 'platforms';
export const COLUMN_REDEEMED = 'redeemedPromoCodes';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_UPDATED_DATE = 'updatedDate';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_UPDATED_BY = 'updatedBy';
export const COLUMN_REQUESTED_BY = 'requestedBy';
export const COLUMN_ACTIVITY_PERIOD = 'activityPeriod';
export const COLUMN_TYPE = 'type';
export const COLUMN_ACTIVITY_TYPE = 'activityType';
export const COLUMN_USAGE_LIMIT = 'usageLimit';
export const COLUMN_EXCLUDED_COUNTRIES = 'excludedCountries';
export const COLUMN_COUNTRIES = 'countries';
export const COLUMN_ATTRIBUTION = 'attributionType';

// form fields
export const STATUS = 'status';
export const ID = 'id';
export const NAME = 'name';

export const INCLUDE_RE_ATTR = 'includeReAttribution';

export const MULTI_REDEMPTION = 'multiRedemption';
export const MAX_REDEMPTIONS_PER_USER = 'maxRedemptionsPerUser';
export const MULTI_REDEMPTION_ACTIVITY_PERIOD = 'multiRedemptionActivityPeriod';
export const MULTI_REDEMPTION_COOLDOWN_PERIOD = 'multiRedemptionCooldownPeriod';

export const APPLICATION = 'applicationId';
export const NUMBER = 'setSize';
export const CAMPAIGNS = 'goGameCampaignsIds';
export const ACTIVITY_TYPE = 'activityType';
export const PLATFORMS = 'platformIds';
export const START_DATE = 'startDate';
export const FINISH_DATE = 'finishDate';
export const PROMO_CODE = 'code';
export const USAGE_LIMIT = 'usageLimit';
export const REWARDS = 'rewards';
export const COMPENSATIONS = 'compensations';

export const CONDITIONAL_REWARDS = 'conditionalRewards';
export const CONDITIONAL_REWARDS_TIMER = 'conditionalRewardsTimer';
export const CONDITIONS = 'conditions';
export const IS_TIME_LIMITED = 'isTimeLimited';
export const CUSTOM_TIMER = 'customTimer';
export const TIMER = 'timer';

export const VALUE = 'value';
export const AFFILIATE = 'affiliateId';
export const REQUESTED_BY = 'requestedBy';
export const COMMENT = 'comment';
export const JIRA_LINK = 'jiraLink';
export const COUNTRIES = 'countryIds';
export const EXCLUDED_COUNTRIES = 'excludedCountryIds';

//statuses
export const STATUS_ACTIVE = 1;
export const STATUS_PENDING = 2;
export const STATUS_EXPIRED = 3;
export const STATUS_INACTIVE = 4;

// fields dependencies
export const DEPENDENCIES = {
  [CAMPAIGNS]: [APPLICATION, AFFILIATE, PLATFORMS, ID, ACTIVITY_TYPE],
  [REWARDS]: [APPLICATION],
  [COMPENSATIONS]: [APPLICATION],
  [ACTIVITY_TYPE]: [CAMPAIGNS, INCLUDE_RE_ATTR],
  [FINISH_DATE]: [
    START_DATE,
    MAX_REDEMPTIONS_PER_USER,
    MULTI_REDEMPTION_COOLDOWN_PERIOD,
  ],
};

//actions
export const ACTION_EDIT = 'edit';
export const ACTION_GET_REDEMPTION_REPORT = 'getRedemptionReport';
export const ACTION_DUPLICATE = 'duplicate';
export const ACTION_DEACTIVATE = 'deactivate';
export const ACTION_DEACTIVATE_AND_DELETE = 'deactivateAndRemove';
export const ACTION_PRESENT_RELATED_CREATIVES = 'relatedCreatives';

export const PERMISSION_ACTION_CREATE_PROMOCODES = 31;
